import {Alert, Form} from "react-bootstrap";
import PropTypes, {array, string} from "prop-types";
import classNames from "classnames";
import {v4 as uuidv4} from "uuid";
import {LabelFor} from "./LabelFor.jsx";
import TooltipInfo from "../TooltipInfo.jsx";

export const Radio = (props) => {


    const groupClassName = classNames({'d-flex align-items-start flex-column': !props.vertical});
    return (
        <Form.Group id={props.id || (props.label + props.name)} name={props.name || props.label || props.ariaLabel}
                    className={groupClassName}>

            <div className={'d-flex align-items-center align-content-center'}>
                <LabelFor label={props.label} id={props.id}  tooltipText={props.tooltipText}/>
            </div>


            {props.options?.map((p, idx) => {
                const optionKey = (props.id || props.name || props.label || props.ariaLabel || props.title) + '_' + idx
                return <Form.Check
                    id={optionKey}
                    key={uuidv4()}
                    aria-label={props.ariaLabel ? props.ariaLabel : undefined}
                    title={props.title}
                    type="radio"
                    label={p.nazwa}
                    className="d-flex align-items-center align-content-center gap-2"
                    value={p.value || p.id}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                    onChange={props.onChange}
                    checked={props.value === p.id}
                />

            })}
            <div>
                {props.errorText && (

                    <Alert className={"p-1 w-100"} variant={"danger"}>
                        <div className={"ms-1"}> {props.errorText}</div>
                    </Alert>

                )}</div>
        </Form.Group>
    );
};


Radio.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.array,
    className: PropTypes.string,
    errorText: PropTypes.oneOfType([string, array]),
    title: PropTypes.string,
    ariaLabel: PropTypes.string,
    readOnly: PropTypes.bool,
    vertical: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    tooltipText: PropTypes.string

};
